import { render } from "./SpeechBox.vue?vue&type=template&id=5b921eef"
import script from "./SpeechBox.vue?vue&type=script&lang=js"
export * from "./SpeechBox.vue?vue&type=script&lang=js"

import "./SpeechBox.vue?vue&type=style&index=0&id=5b921eef&lang=css"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__